import $ from "jquery";
import BigPicture from 'bigpicture';
import AOS from 'aos';
import { Collapse } from "bootstrap";

// Helpers
import { Component } from "./helpers/component";
import { Utils } from "./helpers/utils";
import { Lazyload } from "./helpers/lazyload";

// Components
import { Slider } from "../../components/slider/slider";
Component.register('Slider', Slider);

// On DOM ready
document.addEventListener("DOMContentLoaded", () => {

  Utils.credits();

  Lazyload.init();
  Component.initAll();

  AOS.init({
    disable: window.MSInputMethodContext && document.documentMode // Disabled in IE
  });

  if (window['objectFitImages'] !== undefined) {
    objectFitImages();
  }

  $(document).on('click', 'a[href].lightbox', (e) => {
    e.preventDefault();
    BigPicture({
      "el": e.currentTarget,
      "imgSrc": e.currentTarget.getAttribute('href')
    });
  });

});
